module.exports = __webpack_public_path__ + "img/FFTFormula.10d3a31a.png";